import { Switch } from '@thanx/uikit/switch'
import iconGroupFilled from 'assets/images/icon-group-filled.svg'
import useFlag from 'hooks/useFlag'

import './CustomerCountBadge.scss'

export interface CustomerCountBadgeProps {
  count: number
  onViewClick?: () => void
}

const CustomerCountBadge = ({
  count,
  onViewClick,
}: CustomerCountBadgeProps) => {
  const aiSegmentDetailsEnabled = useFlag('ai-segment-details-enabled', false)
  const isClickable = Boolean(onViewClick) && aiSegmentDetailsEnabled

  const badgeContent = (
    <>
      <img
        src={iconGroupFilled}
        alt=""
        className="customer-count-badge__icon"
        width="16"
        height="16"
      />
      <span>{count.toLocaleString()} customers</span>
      <Switch condition={aiSegmentDetailsEnabled}>
        <span className="customer-count-badge__view">View</span>
      </Switch>
    </>
  )

  if (!isClickable) {
    return (
      <div className="customer-count-badge customer-count-badge--non-interactive">
        {badgeContent}
      </div>
    )
  }

  return (
    <button
      className="customer-count-badge"
      onClick={onViewClick}
      title="View customers"
      type="button"
    >
      {badgeContent}
    </button>
  )
}

export default CustomerCountBadge
